import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { PlayerItemModule } from '../player-item/player-item.module';
import { SelectTeamPlayerComponent } from './select-team-player.component';
import { ListSearchModule } from '../list-search/list-search.module';

@NgModule({
    imports: [
        ReactiveFormsModule,
        FormsModule,
        IonicModule,
        CommonModule,
        TranslateModule.forChild(),
        EmptyPageModule,
        PlayerItemModule,
        ListSearchModule
    ],
    declarations: [
        SelectTeamPlayerComponent,
    ]
})

export class SelectTeamPlayerModule { }
